import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const shipstationV2 = defineConnector({
  identifier: "shipstationV2",
  name: "ShipStation",
  tagLine: "Shipping and order fulfillment",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.shipstation\\.com/.*",
  auth: (app) => headerAuth([{ name: "api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Find your Shipstation (v2) API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [ShipStation authentication docs](https://docs.shipstation.com/authentication) and generate an API key and API secret for the v2 API from your ShipStation account. Copy both values before moving to the next step.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Shipstation (v2) account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "zEfcI+rouT0q1fjQWHBOYnsGYiax3rGDjtt3O5UhFIw",
          helperText: "The API Key for your Shipstation account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.shipstation.com/v2/users?page_size=1",
  },
});
